// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","333":"aeffadc0","468":"164ab698","588":"e9bee512","777":"978fe4b0","779":"e750f2e1","875":"b37fad64","908":"c79c2fa3"}[chunkId] + ".chunk.js";
};